// Static mock data for navbar categories and featured products
// This eliminates API calls and provides instant loading

export const PAINT_CATEGORIES = [
    'Mastics / Putties',
    'Degreasers',
    'Abrasives',
    'Fillers / Apprêts',
    'Ready Mix / Finished Paint',
    'Masking Products',
    'Primers',
    'Stone Chip Protectors',
    'Miscellaneous / Accessories',
    'Varnishes / Clearcoats',
    'Sealants',
    'Paint Equipment / Tools',
    'Thinners / Reducers',
    'Spray Products / Aerosols',
    'Base Coats (Color Mixing System)',
    'Masking',
    'Ready Mix',
    'Thinners',
    'Varnishes',
];

export const WORKWEAR_CATEGORIES = [
    'Polo Shirts',
    'Jackets',
    'Shoes',
    'Pants',
    'T-shirts',
    'Shorts',
    'Coveralls',
    'Gloves',
    'Hi-Vis Vests',
    'Rainwear',
    'Safety Shoes',
    'Shirts',
];

export const FEATURED_PAINT = {
    _id: 'mock-paint-1',
    name: 'Abrasives Paint 1',
    price: 35.00,
    images: ['/assets/product-image.webp'],
    category: 'Paints',
};

export const FEATURED_WORKWEAR = {
    _id: 'mock-workwear-1',
    name: 'Caterpillar Polo Shirt',
    price: 40.00,
    images: ['/assets/product-image.webp'],
    category: 'Workwear',
};
